import React from "react";
import "./App.scss";
import "semantic-ui-css/semantic.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App(props) {
  const { children } = props;
  return (
    <div className="app-page">
      {children} <ToastContainer />
    </div>
  );
}
